import { LeaderboardItem } from "../api/types";
import { Team } from "../types/team";

export const deserializeLeaderboard = (
  supporter: LeaderboardItem,
  index: number,
): Team => ({
  rank: index + 1,
  id: supporter.legacyId,
  name: supporter.title,
  raised: Number(
    supporter.donationAmount ?? 0,
  ) / 100,
  slug: supporter.slug,
  currency: supporter.currencyCode ?? "",
  currencySymbol: supporter.currencySymbol ?? "£",
});
